import { Typography } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ToolWidget from '../../components/public-tools/ToolWidget';

export default function PageSeoAnalyzerPage() {
  return (
    <PublicToolLayout title="Page SEO Analyzer">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Page SEO Analyzer
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Enter any page URL to analyze title length, meta description, heading structure, canonical
        tag, and noindex signals.
      </Typography>
      <ToolWidget
        scanType="PAGE"
        formLabel="Page URL"
        formPlaceholder="https://example.com/your-page"
      />
    </PublicToolLayout>
  );
}
